// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"442":"c5b5ffc8","473":"75df7d94"}[chunkId] + ".chunk.css";
};